import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'timeShort',
})
export class TimeShortPipe implements PipeTransform {

   transform(value: Date | string | null | undefined): string {
    if (!value) return '';
    // value esperado: "HH:mm:ss" o "HH:mm:ss.SSSSSSS"
    return moment(value, ["HH:mm:ss", "HH:mm:ss.SSSSSSS"]).format("HH:mm");
  }

}
